import React from 'react';
import BlockWrapper from './BlockWrapper';
import Container from '../interface/Container';
import SmallBanner from '../SmallBanner/SmallBanner';

const SmallBannerBlock = ({ block }) => {
  return (
    <BlockWrapper>
      <Container>
        <SmallBanner
          mainTitle={block?.mainTitle}
          image={block?.image}
          text={block?.text}
          linkTitle={block?.linkTitle}
          ctaUrl={block?.ctaUrl}
        />
      </Container>
    </BlockWrapper>
  );
};
export default SmallBannerBlock;
